import Vue from 'vue'
import VueRouter from 'vue-router'
import { isAuthenticated, can } from '../auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: { bare: true, title: 'Вход' },
    component: () => import('../pages/login.vue')
  },
  {
    // Разнарядка на несколько дней больше не показывается: главная страница — разнарядка на день
    path: '/',
    name: 'Map',
    redirect: '/schedule/day'
  },
  {
    // Кабинет доступен любому вошедшему пользователю: данные, установка приложения, push-уведомления и привязанные браузеры
    path: '/profile',
    name: 'Profile',
    meta: { title: 'Кабинет' },
    component: () => import('../pages/profile/index.vue')
  },
  {
    path: '/driver-appeals',
    name: 'Appeals',
    meta: { perm: 'page.appeals', title: 'Обращения' },
    component: () => import('../pages/appeals/list.vue')
  },
  {
    path: '/finance',
    name: 'Finance',
    meta: { perm: 'page.finance', title: 'Оплаты мехслужбы' },
    component: () => import('../pages/finance/index.vue')
  },
  {
    path: '/payments',
    name: 'Payments',
    meta: { perm: 'page.payments', title: 'Оплаты' },
    component: () => import('../pages/payments/index.vue')
  },
  {
    path: '/finance/suppliers',
    name: 'FinanceSuppliers',
    meta: { perm: 'page.finance', title: 'Поставщики', kind: 'suppliers' },
    component: () => import('../pages/finance/directory.vue')
  },
  {
    path: '/finance/items',
    name: 'FinanceItems',
    meta: { perm: 'page.finance', title: 'Номенклатура', kind: 'items' },
    component: () => import('../pages/finance/directory.vue')
  },
  {
    path: '/batches',
    name: 'Batches',
    meta: { perm: 'page.batches', title: 'Партии' },
    component: () => import('../pages/batches/list.vue')
  },
  {
    path: '/schedule/day',
    name: 'ScheduleDay',
    meta: { perm: 'page.schedule', title: 'Разнарядка' },
    component: () => import('../pages/schedule/day.vue')
  },
  {
    path: '/routes/add',
    name: 'addRoute',
    meta: { perm: 'page.routes_add', title: 'Добавление маршрута' },
    component: () => import('../pages/routes/addRoute.vue')
  },
  {
    path: '/routes/edit/:id',
    name: 'editRoute',
    meta: { perm: 'page.routes_add', title: 'Редактирование маршрута' },
    component: () => import('../pages/routes/addRoute.vue')
  },
  {
    path: '/routes/list',
    name: 'listRoute',
    meta: { perm: 'page.routes', title: 'Маршруты' },
    component: () => import('../pages/routes/listRoute.vue')
  },
  {
    path: '/routes/shoulder',
    name: 'shoulderCalculator',
    meta: { perm: 'page.shoulder', title: 'Расчёт плеча' },
    component: () => import('../pages/routes/shoulder.vue')
  },
  {
    path: '/orders/add',
    name: 'add',
    meta: { perm: 'page.orders_add', title: 'Новый заказ' },
    component: () => import('../pages/orders/add.vue')
  },
  {
    path: '/orders/edit/:id',
    name: 'edit',
    meta: { perm: 'page.orders_add', title: 'Редактирование заказа' },
    component: () => import('../pages/orders/add.vue')
  },
  {
    path: '/orders/list',
    name: 'list',
    meta: { perm: 'page.orders', title: 'Заказы' },
    component: () => import('../pages/orders/list.vue')
  },
  {
    path: '/repairs/add',
    name: 'repairAdd',
    meta: { perm: 'page.repairs_add', title: 'Заявка на ремонт' },
    component: () => import('../pages/repairs/add.vue')
  },
  {
    path: '/repairs/list',
    name: 'repairList',
    meta: { perm: 'page.repairs', title: 'Ремонтные листы' },
    component: () => import('../pages/repairs/list.vue')
  },
  {
    path: '/report/repairs',
    name: 'repairAnalytics',
    meta: { perm: 'page.repair_analytics', title: 'Аналитика ремонтов' },
    component: () => import('../pages/report/repairs.vue')
  },
  {
    path: '/fuel',
    name: 'fuelList',
    meta: { perm: 'page.fuel', title: 'Топливо' },
    component: () => import('../pages/fuel/list.vue')
  },
  {
    path: '/repairs/gantt',
    name: 'repairGantt',
    meta: { perm: 'page.repairs', title: 'График ремонтов' },
    component: () => import('../pages/repairs/gantt.vue')
  },
  {
    path: '/report/models',
    name: 'reportModels',
    meta: { perm: 'page.report_models', title: 'По моделям 2' },
    component: () => import('../pages/report/models.vue')
  },
  {
    path: '/report/drivers',
    name: 'reportDrivers',
    meta: { perm: 'page.report_drivers', title: 'По водителям' },
    component: () => import('../pages/report/drivers.vue')
  },
  {
    path: '/report/workwear',
    name: 'workwearReport',
    meta: { perm: 'page.report_workwear', title: 'Отчёт по спецодежде' },
    component: () => import('../pages/report/workwear.vue')
  },
  {
    path: '/syncs',
    name: 'syncsList',
    meta: { perm: 'page.syncs', title: 'Синхронизации' },
    component: () => import('../pages/syncs/list.vue')
  },
  {
    path: '/audit',
    name: 'auditList',
    meta: { perm: 'page.audit', title: 'Журнал действий' },
    component: () => import('../pages/audit/list.vue')
  },
  {
    path: '/vehicles',
    name: 'vehiclesList',
    meta: { perm: 'page.vehicles', title: 'Транспортные средства' },
    component: () => import('../pages/vehicles/list.vue')
  },
  {
    path: '/drivers',
    name: 'driversList',
    meta: { perm: 'page.drivers', title: 'Водители' },
    component: () => import('../pages/drivers/list.vue')
  },
  {
    path: '/shift-change',
    name: 'shiftList',
    meta: { perm: 'page.shift_change', title: 'Пересменка' },
    component: () => import('../pages/shift/list.vue')
  },
  {
    path: '/wash',
    name: 'washList',
    meta: { perm: 'page.wash', title: 'Автомойка' },
    component: () => import('../pages/wash/list.vue')
  },
  {
    path: '/zones/now',
    name: 'zonesNow',
    meta: { perm: 'page.zones_now', title: 'Кто где сейчас' },
    component: () => import('../pages/zones/now.vue')
  },
  {
    path: '/zones/stats',
    name: 'zonesStats',
    meta: { perm: 'page.zones_stats', title: 'Статистика заездов' },
    component: () => import('../pages/zones/stats.vue')
  },
  {
    path: '/zones/places',
    name: 'zonesPlaces',
    meta: { perm: 'page.zones_places', title: 'Места' },
    component: () => import('../pages/zones/places.vue')
  },
  {
    path: '/print/car',
    name: 'printCar',
    meta: { perm: 'page.report_car', title: 'По моделям 1' },
    component: () => import('../pages/report/car.vue')
  },
  {
    path: '/users',
    name: 'users',
    meta: { perm: 'page.users', title: 'Пользователи' },
    component: () => import('../pages/users/index.vue')
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    meta: { title: 'Нет доступа' },
    component: () => import('../pages/forbidden.vue')
  },
  {
    path: '/print/route',
    name: 'printRoute',
    meta: { perm: 'page.report_route', title: 'Отчёт по партиям' },
    component: () => import('../pages/report/route.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const BRAND = 'СпецТехРесурс НТ'

// Первая страница, доступная пользователю (для перехода, когда открытая ему недоступна).
// Страницы без разрешения (вход, «Нет доступа») не считаются.
const LANDING_ORDER = [
  '/', '/schedule/day', '/batches', '/orders/list', '/routes/list', '/repairs/list', '/report/repairs', '/fuel', '/wash', '/shift-change', '/vehicles', '/drivers', '/audit', '/syncs', '/zones/now', '/zones/stats', '/zones/places',
  '/routes/shoulder', '/print/car', '/print/route', '/orders/add', '/routes/add', '/repairs/add', '/users'
]

export function firstAllowedPath() {
  const path = LANDING_ORDER.find((p) => {
    const route = routes.find((r) => r.path === p)
    return route && route.meta && route.meta.perm && can(route.meta.perm)
  })
  return path || '/forbidden'
}

// Открыта ли страница текущему пользователю.
export function isRouteAllowed(route) {
  const perm = route && route.meta && route.meta.perm
  return !perm || can(perm)
}

// Авторизация обязательна для всех страниц, кроме самого /login; страница должна быть включена пользователю.
router.beforeEach((to, from, next) => {
  if (to.path === '/login') return next()
  if (!isAuthenticated()) return next({ path: '/login', query: { redirect: to.fullPath } })
  if (!isRouteAllowed(to)) {
    const fallback = firstAllowedPath()
    return fallback === to.path ? next() : next(fallback)
  }
  next()
})

router.afterEach((to) => {
  document.title = to.meta && to.meta.title ? `${to.meta.title} — ${BRAND}` : BRAND
})

export default router
